export var SecurityRuleConstants;
(function (SecurityRuleConstants) {
    SecurityRuleConstants["PRECONFIGURED_BY_LOGZIO"] = "Preconfigured by Logz.io";
    SecurityRuleConstants["LOGZIO_RULE"] = "Logz.io rule";
})(SecurityRuleConstants || (SecurityRuleConstants = {}));
export var SecurityRulesStates;
(function (SecurityRulesStates) {
    SecurityRulesStates["Edit"] = "dashboard.security.rules-v2019-edit";
    SecurityRulesStates["New"] = "dashboard.security.rules-v2019-new";
    SecurityRulesStates["Duplicate"] = "dashboard.security.rules-v2019-duplicate";
})(SecurityRulesStates || (SecurityRulesStates = {}));
export var SigmaRulesSubjects;
(function (SigmaRulesSubjects) {
    SigmaRulesSubjects["SigmaCleanText"] = "sigma-clean-text";
    SigmaRulesSubjects["SigmaConvert"] = "sigma-convert";
    SigmaRulesSubjects["SigmaErrorNotification"] = "sigma-error-notification";
    SigmaRulesSubjects["SigmaConvertorButton"] = "sigma-convertor-button";
    SigmaRulesSubjects["SigmaRuleEditor"] = "sigma-rule-editor";
})(SigmaRulesSubjects || (SigmaRulesSubjects = {}));
//# sourceMappingURL=security.js.map